import React from 'react';
import styled from 'styled-components';

interface MetricProps {
  label: string;
  value: string | number;
  trend?: 'up' | 'down' | 'neutral';
}

const MetricContainer = styled.div`
  background-color: #ffffff;
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
`;

const MetricLabel = styled.div`
  font-size: 14px;
  color: #6c757d;
  margin-bottom: 5px;
`;

const MetricValue = styled.div`
  font-size: 24px;
  font-weight: 600;
  color: #1A2440;
  display: flex;
  align-items: center;
`;

const TrendIndicator = styled.span<{ trend: 'up' | 'down' | 'neutral' }>`
  margin-left: 8px;
  font-size: 14px;
  color: ${props => 
    props.trend === 'up' 
      ? '#4CAF50' 
      : props.trend === 'down' 
        ? '#E45858' 
        : '#6c757d'
  };
`;

const Metric: React.FC<MetricProps> = ({ label, value, trend }) => {
  const getTrendIcon = () => {
    if (trend === 'up') return '↑';
    if (trend === 'down') return '↓';
    return '→';
  };

  return (
    <MetricContainer>
      <MetricLabel>{label}</MetricLabel>
      <MetricValue>
        {value}
        {trend && (
          <TrendIndicator trend={trend}>
            {getTrendIcon()}
          </TrendIndicator>
        )}
      </MetricValue>
    </MetricContainer>
  );
};

export default Metric;
